import React from 'react';
import { hexToLightShade } from '../../../../labelling-v2/hooks/skeleton-template-builder/utils';
import type { TemplateNodeT } from '../../../../labelling-v2/types/skeleton-template-builder.type';
import { CanvasNode } from './canvas-node';
type CanvasNodesPropsT = {
  nodes: TemplateNodeT[];
  hoveredNodeId: string | null;
  selectedNodeId: string | null;
  onSelect: (nodeId: string) => void;
  onHoverChange: (nodeId: string | null) => void;
};
export function CanvasNodes({
  nodes,
  hoveredNodeId,
  selectedNodeId,
  onSelect,
  onHoverChange
}: CanvasNodesPropsT) {
  return <>
      {nodes.map(node => <CanvasNode key={node.id} id={node.id} position={[node.x, node.y]} colors={{
      fill: node.color,
      hover: hexToLightShade(node.color)
    }} highlighted={hoveredNodeId === node.id || selectedNodeId === node.id} onSelect={() => onSelect(node.id)} onHover={hovered => onHoverChange(hovered ? node.id : null)} />)}
    </>;
}